/** @format */
import { Component, Input, ViewEncapsulation } from '@angular/core';
import { Attainment, ModuleAttainment } from 'common-typescript/types';

@Component({
    selector: 'app-module-attainment-details',
    templateUrl: './module-attainment-details.component.html',
    encapsulation: ViewEncapsulation.None,
    standalone: false,
})
export class ModuleAttainmentDetailsComponent {
    @Input() attainment: ModuleAttainment;
    @Input() secondaryAttainments: Attainment[];
    @Input() expirationImminent: boolean;
}
